import { brainerClient } from './client'
import type {
  FunnelConnector, FunnelTable, FunnelRun, FunnelRunLog,
} from '../types'

// ── Connectors ────────────────────────────────────────────────────────────────

export const listFunnelConnectors = () =>
  brainerClient.get<FunnelConnector[]>('/funnel/connectors')

export const createFunnelConnector = (d: {
  title: string; connectorType: string; host: string; port: number
  databaseName?: string; username: string; password?: string; storageDatasetId?: string | null
  sftpConnectorId?: string | null; sftpRemotePath?: string | null; sftpFileTypeFilter?: string | null
  sftpAuthType?: 'password' | 'key'; privateKey?: string
}) => brainerClient.post<{ connector: FunnelConnector; tables: string[] }>('/funnel/connectors', d)

export const getFunnelConnector = (id: string) =>
  brainerClient.get<FunnelConnector & { tables: FunnelTable[] }>(`/funnel/connectors/${id}`)

export const updateFunnelConnector = (id: string, d: Partial<{
  title: string; host: string; port: number
  databaseName: string; username: string; password: string; storageDatasetId: string | null
  sftpConnectorId: string | null; sftpRemotePath: string | null; sftpFileTypeFilter: string | null
  sftpAuthType: 'password' | 'key'; privateKey: string
}>) => brainerClient.put<FunnelConnector>(`/funnel/connectors/${id}`, d)

export const deleteFunnelConnector = (id: string) =>
  brainerClient.delete(`/funnel/connectors/${id}`)

// ── Schema discovery ──────────────────────────────────────────────────────────

export const getSourceTables = (connectorId: string) =>
  brainerClient.get<string[]>(`/funnel/connectors/${connectorId}/source-tables`)

export const getSourceColumns = (connectorId: string, tables: string[]) =>
  brainerClient.post<Record<string, string[]>>(`/funnel/connectors/${connectorId}/source-columns`, { tables })

// ── Config ────────────────────────────────────────────────────────────────────

export const saveFunnelConfig = (connectorId: string, config: {
  tables: Array<{
    tableName: string; cupName: string | null; tableType: 'data' | 'relation'
    idColumn: string; isAutoIncluded: boolean
    columns?: Array<{ columnName: string; isRelation: boolean; relationTargetTable: string | null; relationTargetIdColumn: string | null; relationLabel?: string | null; ingredientId?: string | null }>
    links?: Array<{ linkedTableName: string; linkedIdColumn: string; position: 1 | 2 }>
    label?: string | null
  }>
}) => brainerClient.post(`/funnel/connectors/${connectorId}/config`, config)

// ── Runs ──────────────────────────────────────────────────────────────────────

export const getFunnelRuns = (connectorId: string) =>
  brainerClient.get<FunnelRun[]>(`/funnel/connectors/${connectorId}/runs`)

export const startFunnelRun = (connectorId: string) =>
  brainerClient.post<FunnelRun>(`/funnel/connectors/${connectorId}/runs`)

export const stopFunnelRun = (runId: string) =>
  brainerClient.post(`/funnel/runs/${runId}/cancel`)

export const deleteFunnelRun = (runId: string) =>
  brainerClient.delete(`/funnel/runs/${runId}`)

export const getFunnelRunLogs = (runId: string) =>
  brainerClient.get<FunnelRunLog[]>(`/funnel/runs/${runId}/logs`)
